import zxcvbn from 'zxcvbn'

export const validatePassword = password => {
  const errors = []

  const hasUppercase = /[A-Z]/.test(password)
  const hasLowercase = /[a-z]/.test(password)
  const hasNumber = /[0-9]/.test(password)
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
  const hasMinLength = password.length >= 8

  if (!hasUppercase) errors.push('At least one uppercase letter')
  if (!hasLowercase) errors.push('At least one lowercase letter')
  if (!hasNumber) errors.push('At least one number')
  if (!hasSpecialChar) errors.push('At least one special character')
  if (!hasMinLength) errors.push('Minimum length of 8 characters')

  const strength = zxcvbn(password)
  if (strength.score < 3) {
    errors.push('Password is too weak — try a less predictable one')
  }

  return {
    valid: errors.length === 0,
    errors,
    score: strength.score,
    feedback: strength.feedback,
  }
}

export const generatePassword = (length = 16) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz'
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const digits = '0123456789'
  const symbols = '!@#$%^&*()-_=+[]{};:,.?/'

  const all = lower + upper + digits + symbols

  // ensure at least one from each group
  const pick = s => s[Math.floor(Math.random() * s.length)]
  let pw = [pick(lower), pick(upper), pick(digits), pick(symbols)]

  for (let i = pw.length; i < length; i++) pw.push(pick(all))

  // shuffle
  for (let i = pw.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[pw[i], pw[j]] = [pw[j], pw[i]]
  }

  return pw.join('')
}

export const copyToClipboard = async text => {
  if (!text) return
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    // fallback
    const ta = document.createElement('textarea')
    ta.value = text
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  }
}
